module.exports = global["MobileDetect"] = require("-!/var/www/html/node_modules/mobile-detect/mobile-detect.js");


//////////////////
// WEBPACK FOOTER
// ./~/mobile-detect/mobile-detect.js
// module id = 361
// module chunks = 0